export const parseTransformString = (transform: string) => {
  return Object.fromEntries(
    transform
      .trim()
      .split(') ')
      .map((i, index, arr) => (index === arr.length - 1 ? i : i + ')').trim())
      .map((i) => {
        const separatorIndex = i.indexOf('(');

        if (separatorIndex === -1) return null;

        const key = i.substring(0, separatorIndex);
        const value = i.substring(separatorIndex + 1, i.length - 1);

        return [key, value];
      })
      .filter(Boolean) as unknown as [string, string][]
  );
};
